import { t } from "i18next";
import { CLEAN, ERROR_SERVER, GET_AREAS, SET_ACCESS_AREAS_SELECTED, SET_FREE_ACCESS } from "./types";

const AccessAreaReducer = (state, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_AREAS:
            return {
                ...state,
                accessAreas: payload,
                accessAreasSearcheable: payload,
                canShowMore: false,
                error: false,
                message: '',
                isFetching: false,
            };
        case ERROR_SERVER:
            return {
                ...state,
                error: true,
                isFetching: false,
                message: payload,
            };
        case SET_ACCESS_AREAS_SELECTED:
            return {
                ...state,
                accessAreasSelected: payload,
            };
        case CLEAN:
            return {
                accessAreas: [],
                accessAreasSearcheable: [],
                isFetching: true,
                canShowMore: false,
                error: false,
                message: '',
                accessAreasSelected: {
                    area_id: "",
                    code: "",
                    description: t('FREE_ACCESS_AREA')
                },
            };
        case SET_FREE_ACCESS:
            return {
                ...state,
                freeAccess: payload,
            };
        default:
            return state;
    }
}

export default AccessAreaReducer